import type {
    AiChatFileIngestionStatus,
    AiChatSource,
    ChatId,
    ChatPromptId,
} from '../../../shared/domain/aiChats/types.no-deps'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import type { IngestEntityError } from '../../../shared/lib/aws/lambda/ingestEntity.no-deps'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { CommonDeps } from '../base/CommonDeps'

export type PromptAnswer = {
    chatId: ChatId
    promptId: ChatPromptId
    text: string
    sources: AiChatSource[]
    predefinedAnswer: Nullable<string>
    hasError: boolean
}

export type UiChatFile = {
    fileMetaId: FileId
    file: File
    status: AiChatFileIngestionStatus
    errorCode: IngestEntityError['code']
    abortController: AbortController
}

export type UiChatFilesMap = Map<FileId, UiChatFile>

export type BaseSourceProps = {
    deps: CommonDeps
    number: number
    source: AiChatSource
}

export enum ZapBotModalPage {
    Main = 'main',
    PrivacyPolicy = 'privacy-policy',
    CreditsInfo = 'credits-info',
    GuideExecution = 'guide-execution',
}

export const INITIAL_PROMPT_ANSWER: PromptAnswer = {
    chatId: null,
    promptId: null,
    text: '',
    sources: [],
    predefinedAnswer: null,
    hasError: false,
}
